/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import './button.scss';
import PropTypes from 'prop-types';
import { useGlobalBackButton } from '../../GlobalBackButtonContext';

const button = require('b_').with('button');

export const Button = ({
    type, title, onClick, disabled, mod, children, visible,
}) => (!visible ? null : (
    // eslint-disable-next-line react/button-has-type
    <button type={type} disabled={disabled} onClick={onClick} className={button(mod)}>
        {title}
        {children}
    </button>
));

Button.GO_BACK_FORM_TITLE = ({ onBackPress, disabled }) => {
    const history = useHistory();
    const { state } = useLocation();
    const { onBack } = useGlobalBackButton();
    return (
        <Button
            mod={{
                reverse: true,
                icon: 'chevron--left',
                small: true,
            }}
            onClick={() => {
                if (onBack) {
                    onBack();
                }
                // history.goBack(); // uncomment this line if we will use history. Rework DoctorServiceBooking.jsx as a separate page
            }}
            disabled={!state && disabled}
        />
    );
};

Button.propTypes = {
    title: PropTypes.string.isRequired,
    mod: PropTypes.oneOfType([ PropTypes.instanceOf(Object), PropTypes.string ]),
    onClick: PropTypes.oneOfType([ PropTypes.func, PropTypes.string ]),
    children: PropTypes.element,
    disabled: PropTypes.bool,
    visible: PropTypes.bool,
    type: PropTypes.string,
};

Button.defaultProps = {
    mod: '',
    children: React.Element,
    disabled: false,
    visible: true,
    onClick: '',
    type: 'button',
};
